import Corkboard from './Corkboard'
import Header from './Header'
import Card from './Card'
import './SiteMap.css'
import { useEffect } from 'react'
import Nelson from './Nelson'

const SiteMap = ({ onScreenUpdate }) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="siteMapContainer">
      <Header onScreenUpdate={onScreenUpdate} />

      <Corkboard onScreenUpdate={onScreenUpdate}>
        <div className="siteMap">
          <div className="siteMapGroup">
            <div className="siteMapGroupHeader">By Topic</div>

            <div className="siteMapCardGroup">
              <Card className="siteMapCard">
                <div className="siteMapCardTitle">
                  Healthcare &amp; Nutrition
                </div>

                <div className="linksLink">
                  <a
                    href="pages/healthcare/healthFAQ.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Healthcare FAQs
                  </a>
                </div>
                <div className="linksLink">
                  <a
                    href="pages/healthcare/feedingYourHorse.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Horse Food
                  </a>
                </div>
                <div className="linksLink">
                  <a
                    href="pages/healthcare/feedingOlderHorses.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Feeding Older Horses
                  </a>
                </div>
                <div className="linksLink">
                  <a
                    href="pages/healthcare/feedingAthletes.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Feeding Four-Legged Athletes
                  </a>
                </div>
              </Card>
              <Card className="siteMapCard">
                <div className="siteMapCardTitle">
                  Horses &amp; the Environment
                </div>

                <div className="linksLink">
                  <a
                    href="pages/environment/envirFAQ.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Environment FAQs
                  </a>
                </div>
                <div className="linksLink">
                  <a
                    href="pages/environment/scoopOnPoop.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Scoop on Poop
                  </a>
                </div>
                <div className="linksLink">
                  <a
                    href="pages/environment/goingGreen.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Going Green
                  </a>
                </div>
                <div className="linksLink">
                  <a
                    href="https://esc.rutgers.edu/research/ryders-lane-farm/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Ryders Lane Farm Virtual Tour
                  </a>
                </div>
              </Card>
              <Card className="siteMapCard">
                <div className="siteMapCardTitle">Exercise Physiology</div>
                <div className="linksLink">
                  <a
                    href="pages/exercise/FAQ1.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Exercise FAQs
                  </a>
                </div>
                <div className="linksLink">
                  <a
                    href="https://youtu.be/c87tCgT9ZBU"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Video: Horses on Treadmills?
                  </a>
                </div>
                <div className="linksLink">
                  <a
                    href="https://esc.rutgers.edu/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Treadmill Lab Virtual Tour
                  </a>
                </div>
              </Card>
            </div>
          </div>
          <div className="siteMapGroup">
            <div className="siteMapGroupHeader">Misc</div>
            <div className="siteMapCardGroup">
              <Card className="siteMapCard">
                <div className="siteMapCardTitle">Lord Nelson</div>
                <div className="linksLink">
                  <a
                    href="/pages/main/nelsonBio.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Lord Nelson's Bio
                  </a>
                </div>
                <div className="linksLink">
                  <a
                    href="https://esc.rutgers.edu/blog/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Lord Nelson's Blog
                  </a>
                </div>
                <div className="linksLink">
                  <a
                    href="pages/kids/html/main/joinFanClub.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Lord Nelson's Fan Club
                  </a>
                </div>
                <div className="linksLink">
                  <a
                    href="mailto:LordNelson@njaes.rutgers.edu?subject=Horses and%20the%20environment%20-%20frequently%20asked%20questions"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Email Lord Nelson
                  </a>
                </div>
              </Card>

              <Card className="siteMapCard">
                <div className="siteMapCardTitle">Contact Us</div>
                <div className="linksLink">
                  <a
                    href="https://www.facebook.com/RutgersESC/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Equine Science Center on Facebook
                  </a>
                </div>
                <div className="linksLink">
                  <a
                    href="mailto:esc@njaes.rutgers.edu"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Email the Equine Science Center!
                  </a>
                </div>
              </Card>
              <Card className="siteMapCard">
                <div className="siteMapCardTitle">Other Links</div>
                <div className="linksLink">
                  <a
                    href="https://esc.rutgers.edu/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Equine Science Center Home
                  </a>
                </div>
                <div className="linksLink">
                  <a
                    href="https://njaes.rutgers.edu/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    NJ Agricultural Experiment Station
                  </a>
                </div>
                <div className="linksLink">
                  <a
                    href="https://nj4h.rutgers.edu/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    NJ 4-H Rutgers
                  </a>
                </div>
              </Card>
            </div>
          </div>
        </div>
      </Corkboard>
      <Nelson />
    </div>
  )
}

export default SiteMap
